/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { PACK, SURVEY } from '@constants/terminology';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

interface RemoveArchivedScopeModalProps {
  /** A beta module the company no longer has, rather than an archived one */
  isBeta?: boolean;
  handleSubmit: () => void;
  handleClose: () => void;
}

export const RemoveArchivedScopeModal = ({ isBeta, handleSubmit, handleClose }: RemoveArchivedScopeModalProps) => {
  return (
    <Modal isOpen={true} toggle={handleClose} backdrop='static'>
      <ModalHeader toggle={handleClose}>
        {isBeta ? `Removing beta ${PACK.SINGULAR}` : `Removing archived scope ${PACK.SINGULAR}`}
      </ModalHeader>
      <ModalBody>
        {isBeta ? (
          <>
            This beta {PACK.SINGULAR} is no longer enabled for your company. Once removed you will not be able to add
            it back to your {SURVEY.SINGULAR} scope. Do you wish to continue?
          </>
        ) : (
          <>
            You are about to remove an archived scope {PACK.SINGULAR} from your {SURVEY.SINGULAR} scope selection.
            Once removed you will not be able to re-add this scope {PACK.SINGULAR} to your {SURVEY.PLURAL} scope. Do
            you wish to continue?
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color='link-secondary' className='mr-2' onClick={handleClose}>
          Cancel
        </Button>
        <Button color='danger' onClick={handleSubmit}>
          Remove {PACK.SINGULAR}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
